<template>
  <div id="container"></div>
</template>

<script>
  export default {
    name: 'BDMap',
    data() {
      return {}
    },
    methods: {},
    mounted: function() {
      var map = new BMap.Map('mapcontainer')
      var point = new BMap.Point(116.477692,39.918167);  // 创建点坐标
      var marker=new BMap.Marker(new BMap.Point(116.482892,39.916167));//设置坐标
      map.addOverlay(marker);
      map.panTo(point)

      map.enableScrollWheelZoom(true);
      map.centerAndZoom(point, 18);                 // 初始化地图，设置中心点坐标和地图级别
      function SearchControl(){
        // this.defaultAnchor = BMAP_ANCHOR_TOP_LEFT;    //相对于左上角
        // this.defaultOffset = new BMap.Size(100, 20);    //相对于图标左上角的位置
      }

      SearchControl.prototype = new BMap.Control();
      SearchControl.prototype.initialize = function(map){
        var div=$("<div><font size='2'>关键字</font><input id='mytext' type='text'><input id='mybtn' type='button' value='查询'></div>");
        $(map.getContainer()).append(div);//将以上的html添加到地图中覆盖
        $("#mybtn").css("border-radius",8);//设置按钮圆角
        $("#mybtn").on("click",function(){ //按钮点击后 调用api搜索
          var val=$("#mytext").val();
          var local = new BMap.LocalSearch(map, {
            renderOptions:{map: map}
          });
          local.search(val);
        });
        return div[0];
      }
      var myIcon = new BMap.Icon("${context.ctx!}/resource/img/markers.png", new BMap.Size(23, 25), {
        offset: new BMap.Size(10, 25),
        imageOffset: new BMap.Size(0, 0 - 10 * 25) // 设置图片偏移
      });
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/BDMap.vue